// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spinAround-data-v-10154abd{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.c-entry-detail__title[data-v-10154abd]{margin-bottom:2.5rem}.c-entry-detail__meta[data-v-10154abd]{margin-bottom:1.5rem}.c-entry-detail__meta table.table tr td[data-v-10154abd]:first-child,.c-entry-detail__meta table.table tr th[data-v-10154abd]:first-child{padding-left:0}\n", ""]);
// Exports
module.exports = exports;
